module.exports = __webpack_public_path__ + "91ace6a603f91093096b0b54d38a15cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jewelry-photo/img/jewelry-placeholder@2x.png
// module id = 766
// module chunks = 0